<template>
  <div class="inicio">
    <md-layout md-flex="100" md-align="center" md-gutter="24" class="m-t-24">
      <md-layout md-column md-flex-xsmall="100" md-flex-small="50" md-flex-medium="25" md-flex-large="20" md-flex-xlarge="15">
        <md-card class="md-accent m-b-24">
          <md-card-media-cover>
            <md-card-media>
              <img :src="foto"></img>
            </md-card-media>
            <md-card-area>
              <md-card-actions>
                <md-button class="md-icon-button" @click.native="abrirModal('modalCambiarFotoEmpleado')">
                  <md-icon>photo_camera</md-icon>
                </md-button>
              </md-card-actions>
            </md-card-area>
          </md-card-media-cover>
          <md-card-header>
            <div class="md-title">
              {{empleado.nombre_emn}} {{empleado.ap_pat_emn}} {{empleado.ap_mat_emn}}
              <small>#{{empleado.id_emn}}</small>
            </div>
            <div class="md-subhead">{{empleado.sexo_emn.toUpperCase() }}, {{empleado.edad}} AÑOS</div>
            <br>
            <div class="md-subhead">{{empleado.estatus_ene.toUpperCase() }} DESDE {{empleado.desde_ene}}</div>
            <div class="md-subhead">
              <strong>PUESTO: </strong>{{empleado.nombre_pue}},
              <small>{{empleado.descripcion_pue}}</small>
            </div>
          </md-card-header>
          <md-card-actions>
            <md-button class="md-raised" @click.native="irEditarEmpleado()">Editar</md-button>
          </md-card-actions>
        </md-card>
      </md-layout>
      <md-layout md-column md-flex-xsmall="100" md-flex-small="50" md-flex-medium="75" md-flex-large="75" md-flex-xlarge="75">
        <md-tabs md-fixed>
          <md-tab id="general" md-label="General">
            <div id="datos-generales" class="m-t-8">
              <div class="md-title">
                <md-icon>face</md-icon> Información general
              </div>
              <md-layout md-flex="100" md-gutter="16">
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Sexo: </strong> {{empleado.sexo_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Fecha de nacimiento: </strong> {{empleado.fecha_nac_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Edad: </strong> {{empleado.edad}} años
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Estado civil: </strong> {{empleado.estado_civil_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Escolaridad: </strong> {{empleado.escolaridad_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Tipo de sangre: </strong> {{empleado.tipo_sangre_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>NSS: </strong> {{empleado.nss_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Cuenta bancaria: </strong> {{empleado.cuenta_ban_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>CURP: </strong> {{empleado.curp_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>RFC: </strong> {{empleado.rfc_emn}}
                </md-layout>
              </md-layout>
            </div>
            <div id="domicilio" class="m-t-24">
              <div class="md-title">
                <md-icon>home</md-icon> Domicilio
              </div>
              {{empleado.direccion_emn}} #{{empleado.num_ext_emn}}. COLONIA {{empleado.colonia_emn}}, C.P. {{empleado.codigo_postal_emn}}<br> {{empleado.municipio_emn}}, {{empleado.estado_emn}}<br>
            </div>
            <div id="contacto" class="m-t-24">
              <div class="md-title">
                <md-icon>phone</md-icon> Contacto
              </div>
              <div v-if="empleado.tel_emn">
                <strong>Teléfono: </strong>
                <a :href="'tel:'+ empleado.tel_emn">{{empleado.tel_emn}}</a>
              </div>
              <div v-if="empleado.cel_emn">
                <strong>Celular: </strong>
                <a :href="'tel:'+empleado.cel_emn">{{empleado.cel_emn}}</a>
              </div>
              <div v-if="empleado.email_emn">
                <strong>Correo electrónicos: </strong>
                <a :href="'mailto:'+ empleado.email_emn">{{empleado.email_emn}}</a>
              </div>
            </div>
            <div id="familiar" class="m-t-24">
              <div class="md-title">
                <md-icon>wc</md-icon>
                <md-icon>notifications_active</md-icon> Información familiar y de emergencia
              </div>
              <md-layout md-flex="100" md-gutter="16">
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Persona de contacto: </strong> {{empleado.persona_contacto_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Teléfono de contacto: </strong>
                  <a :href="'tel:'+ empleado.tel_emn">{{empleado.tel_contacto_emn}}</a>
                </md-layout>
                <md-layout md-flex="100">
                  <strong>Dirección de contacto: </strong> {{empleado.direccion_contacto_emn}} #{{empleado.num_contacto_emn}}, COLONIA {{empleado.colonia_contacto_emn}}
                </md-layout>
              </md-layout>
              <md-layout md-flex="100" md-gutter="16" class="m-t-8">
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Nombre del cónyugye: </strong> {{empleado.nombre_conyuge_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Teléfono del cónyugye: </strong> {{empleado.tel_conyuge_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Hijos: </strong> {{empleado.hijos_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Dependientes: </strong> {{empleado.dependientes_emn}}
                </md-layout>
              </md-layout>
            </div>
            <div id="corporal" class="m-t-24">
              <div class="md-title">
                <md-icon>accessibility</md-icon> Características corporales
              </div>
              <md-layout md-flex="100" md-gutter="16">
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Peso: </strong> {{empleado.peso_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Estatura: </strong> {{empleado.estatura_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Camisa: </strong> {{empleado.camisa_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Pantalon: </strong> {{empleado.pantalon_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Calzado: </strong> {{empleado.calzado_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Complexion: </strong> {{empleado.complexion_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Ojos: </strong> {{empleado.ojos_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Piel: </strong> {{empleado.piel_emn}}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="33">
                  <strong>Cabello: </strong> {{empleado.cabello_emn}}
                </md-layout>
              </md-layout>
            </div>
            <p>
              "experiencia_emn":null,<br> "anos_exp_emn":null,
              <br> "observaciones_emn":null,
              <br>
            </p>
          </md-tab>
          <md-tab id="roles" md-label="Roles">
            <md-card>
              <md-tabs md-fixed class="md-accent">
                <md-tab id="roles-activos" md-label="Actuales">
                  <md-table>
                    <md-table-header>
                      <md-table-row>
                        <md-table-head>Punto</md-table-head>
                        <md-table-head>Horario</md-table-head>
                        <md-table-head>Toca</md-table-head>
                        <md-table-head>L1</md-table-head>
                        <md-table-head>M1</md-table-head>
                        <md-table-head>M1</md-table-head>
                        <md-table-head>J1</md-table-head>
                        <md-table-head>V1</md-table-head>
                        <md-table-head>S1</md-table-head>
                        <md-table-head>D1</md-table-head>
                      </md-table-row>
                    </md-table-header>
                    <md-table-body>
                      <md-table-row v-for="ra in roles_activos" :key="ra.id_rol">
                        <md-table-cell>{{ra.nombre_pun}}</md-table-cell>
                        <md-table-cell> {{moment(ra.inicio_ptu,'h:mm:ss').format('h:mm A')}} - {{moment(ra.termino_ptu,'h:mm:ss').format('h:mm A')}}</md-table-cell>
                        <md-table-cell>
                          <md-icon>{{ra.cambio_rol === 'activo' ? 'filter_1' : 'filter_2'}}</md-icon>
                          <md-tooltip>Rol {{ra.cambio_rol === 'activo' ? 'esta' : 'la siguiente'}} semana</md-tooltip>
                        </md-table-cell>
                        <md-table-cell>
                          <md-icon v-if="ra.lun1_rol === '1'">check</md-icon>
                          <md-icon v-else class="md-warn">pause</md-icon>
                        </md-table-cell>
                        <md-table-cell>
                          <md-icon v-if="ra.mar1_rol === '1'">check</md-icon>
                          <md-icon v-else class="md-warn">pause</md-icon>
                        </md-table-cell>
                        <md-table-cell>
                          <md-icon v-if="ra.mie1_rol === '1'">check</md-icon>
                          <md-icon v-else class="md-warn">pause</md-icon>
                        </md-table-cell>
                        <md-table-cell>
                          <md-icon v-if="ra.jue1_rol === '1'">check</md-icon>
                          <md-icon v-else class="md-warn">pause</md-icon>
                        </md-table-cell>
                        <md-table-cell>
                          <md-icon v-if="ra.vie1_rol === '1'">check</md-icon>
                          <md-icon v-else class="md-warn">pause</md-icon>
                        </md-table-cell>
                        <md-table-cell>
                          <md-icon v-if="ra.sab1_rol === '1'">check</md-icon>
                          <md-icon v-else class="md-warn">pause</md-icon>
                        </md-table-cell>
                        <md-table-cell>
                          <md-icon v-if="ra.dom1_rol === '1'">check</md-icon>
                          <md-icon v-else class="md-warn">pause</md-icon>
                        </md-table-cell>
                      </md-table-row>
                    </md-table-body>
                  </md-table>
                </md-tab>
                <md-tab id="roles-inactivos" md-label="Pasados">
                  <md-table>
                    <md-table-header>
                      <md-table-row>
                        <md-table-head>Punto</md-table-head>
                        <md-table-head>Horario</md-table-head>
                        <md-table-head>L1</md-table-head>
                        <md-table-head>M1</md-table-head>
                        <md-table-head>M1</md-table-head>
                        <md-table-head>J1</md-table-head>
                        <md-table-head>V1</md-table-head>
                        <md-table-head>S1</md-table-head>
                        <md-table-head>D1</md-table-head>
                      </md-table-row>
                    </md-table-header>
                    <md-table-body>
                      <md-table-row v-for="ri in roles_inactivos" :key="ri.id_rol">
                        <md-table-cell>{{ri.nombre_pun}}</md-table-cell>
                        <md-table-cell> {{moment(ri.inicio_ptu,'h:mm:ss').format('h:mm A')}} - {{moment(ri.termino_ptu,'h:mm:ss').format('h:mm A')}}</md-table-cell>
                        <md-table-cell>
                          <md-icon v-if="ri.lun1_rol === '1'">check</md-icon>
                          <md-icon v-else class="md-warn">pause</md-icon>
                        </md-table-cell>
                        <md-table-cell>
                          <md-icon v-if="ri.mar1_rol === '1'">check</md-icon>
                          <md-icon v-else class="md-warn">pause</md-icon>
                        </md-table-cell>
                        <md-table-cell>
                          <md-icon v-if="ri.mie1_rol === '1'">check</md-icon>
                          <md-icon v-else class="md-warn">pause</md-icon>
                        </md-table-cell>
                        <md-table-cell>
                          <md-icon v-if="ri.jue1_rol === '1'">check</md-icon>
                          <md-icon v-else class="md-warn">pause</md-icon>
                        </md-table-cell>
                        <md-table-cell>
                          <md-icon v-if="ri.vie1_rol === '1'">check</md-icon>
                          <md-icon v-else class="md-warn">pause</md-icon>
                        </md-table-cell>
                        <md-table-cell>
                          <md-icon v-if="ri.sab1_rol === '1'">check</md-icon>
                          <md-icon v-else class="md-warn">pause</md-icon>
                        </md-table-cell>
                        <md-table-cell>
                          <md-icon v-if="ri.dom1_rol === '1'">check</md-icon>
                          <md-icon v-else class="md-warn">pause</md-icon>
                        </md-table-cell>
                      </md-table-row>
                    </md-table-body>
                  </md-table>
                </md-tab>
              </md-tabs>
            </md-card>
          </md-tab>
          <md-tab id="sueldo" md-label="Sueldo">
            <div id="sueldo-actual">
              <div class="md-title">Salario semanal actual: {{numberFormat(empleado.salario_qnal_pnh)}}</div>
              <md-layout md-flex="100" md-gutter="16" class="m-t-24">
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="25">
                  <strong>Falta justificada: </strong>{{ numberFormat(empleado.falta_just_pnh) }}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="25">
                  <strong>Falta injustificada: </strong>{{ numberFormat(empleado.falta_injust_pnh) }}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="25">
                  <strong>Permiso: </strong>{{ numberFormat(empleado.permiso_pnh) }}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="25">
                  Permiso por fallecimiento {{ numberFormat(empleado.permiso_falle_pnh) }}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="25">
                  <strong>Permiso por nacimiento: </strong>{{ numberFormat(empleado.permiso_naci_pnh) }}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="25">
                  <strong>Hora de tiempo extra: </strong>{{ numberFormat(empleado.hora_tie_ext_pnh) }}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="25">
                  <strong>Tiempo extra: </strong>{{ numberFormat(empleado.tie_ext_pnh) }}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="25">
                  <strong>Dobre turno: </strong>{{ numberFormat(empleado.doble_turno_pnh) }}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="25">
                  <strong>Día festivo: </strong>{{ numberFormat(empleado.dia_festivo_pnh) }}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="25">
                  <strong>Día 31: </strong>{{ numberFormat(empleado.dia_tresuno_pnh) }}
                </md-layout>
                <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-flex-large="33" md-flex-xlarge="25">
                  <strong>Día 28: </strong>{{ numberFormat(empleado.dia_dosocho_pnh) }}
                </md-layout>
              </md-layout>
            </div>
            <md-button class="md-raised md-accent" @click.native="abrirModal('modalCambiarPlanPago')">Cambiar plan de pago</md-button>
            <md-table-card class="m-t-24">
              <md-card-header>
                <div class="md-title">Historial de salarios</div>
              </md-card-header>
              <md-table>
                <md-table-header>
                  <md-table-row>
                    <md-table-head>Asignado</md-table-head>
                    <md-table-head>Desasignado</md-table-head>
                    <md-table-head>Plan</md-table-head>
                    <md-table-head>Salario semanal</md-table-head>
                    <md-table-head>Desde plan</md-table-head>
                    <md-table-head>Hasta plan</md-table-head>
                  </md-table-row>
                </md-table-header>
                <md-table-body>
                  <md-table-row v-for="s in salarios_historial" :key="s.desde_eph">
                    <md-table-cell>{{ s.desde_eph }}</md-table-cell>
                    <md-table-cell>
                      <div v-if="s.hasta_eph">
                        {{ s.hasta_eph }}
                      </div>
                    </md-table-cell>
                    <md-table-cell>{{ s.nombre_pln }}</md-table-cell>
                    <md-table-cell>{{ numberFormat(s.salario_qnal_pnh) }}</md-table-cell>
                    <md-table-cell>{{ moment(s.desde_pnh).format('YYYY-MM-DD') }}</md-table-cell>
                    <md-table-cell>
                      <div v-if="s.hasta_pnh != '0000-00-00 00:00:00'">
                        {{ moment(s.hasta_pnh).format('YYYY-MM-DD') }}
                      </div>
                    </md-table-cell>
                  </md-table-row>
                </md-table-body>
              </md-table>
            </md-table-card>
          </md-tab>
          <md-tab id="per-ded" md-label="Percepciones y deducciones">
            <md-card class="m-t-24">
              <md-tabs md-fixed class="md-accent">
                <md-tab id="pdn_activas" md-label="Activas">
                  <md-table>
                    <md-table-header>
                      <md-table-row>
                        <md-table-head>Concepto</md-table-head>
                        <md-table-head>Tipo</md-table-head>
                        <md-table-head>Desde</md-table-head>
                        <md-table-head>Sems</md-table-head>
                        <md-table-head>Importe</md-table-head>
                        <md-table-head>Restante</md-table-head>
                        <md-table-head v-if="editar_nomina">Acciones</md-table-head>
                      </md-table-row>
                    </md-table-header>
                    <md-table-body>
                      <md-table-row v-for="(pda,index) in per_ded_activos" :key="index">
                        <md-table-cell>{{pda.desc_con}}</md-table-cell>
                        <md-table-cell>{{pda.tipo_con.toUpperCase()}}</md-table-cell>
                        <md-table-cell>{{pda.desde_pdn}}</md-table-cell>
                        <md-table-cell>{{pda.qnas_pdn}}</md-table-cell>
                        <md-table-cell>{{numberFormat(pda.importe_pdn)}}</md-table-cell>
                        <md-table-cell>{{numberFormat(pda.resto_pdn)}}</md-table-cell>
                        <md-table-cell v-if="editar_nomina">
                          <md-button class="md-icon-button">
                            <md-icon @click.native="cambiarEstatusConcepto(pda.id_pdn,'inactivo')">pause</md-icon>
                            <md-tooltip md-direction="left">Suspender concepto</md-tooltip>
                          </md-button>
                        </md-table-cell>
                      </md-table-row>
                    </md-table-body>
                  </md-table>
                </md-tab>
                <md-tab id="pdn_inactivas" md-label="Inactivas">
                  <md-table>
                    <md-table-header>
                      <md-table-row>
                        <md-table-head>Concepto</md-table-head>
                        <md-table-head>Tipo</md-table-head>
                        <md-table-head>Desde</md-table-head>
                        <md-table-head>Hasta</md-table-head>
                        <md-table-head>Sems</md-table-head>
                        <md-table-head>Importe</md-table-head>
                        <md-table-head>Restante</md-table-head>
                        <md-table-head>Acciones</md-table-head>
                      </md-table-row>
                    </md-table-header>
                    <md-table-body>
                      <md-table-row v-for="(pdi,index) in per_ded_inactivos" :key="index">
                        <md-table-cell>{{pdi.desc_con}}</md-table-cell>
                        <md-table-cell>{{pdi.tipo_con.toUpperCase()}}</md-table-cell>
                        <md-table-cell>{{pdi.desde_pdn}}</md-table-cell>
                        <md-table-cell>{{pdi.hasta_pdn}}</md-table-cell>
                        <md-table-cell>{{pdi.qnas_pdn}}</md-table-cell>
                        <md-table-cell>{{numberFormat(pdi.importe_pdn)}}</md-table-cell>
                        <md-table-cell>{{numberFormat(pdi.resto_pdn)}}</md-table-cell>
                        <md-table-cell>
                          <md-button class="md-icon-button">
                            <md-icon @click.native="cambiarEstatusConcepto(pdi.id_pdn,'activo')">play_arrow</md-icon>
                            <md-tooltip md-direction="left">Activar concepto</md-tooltip>
                          </md-button>
                        </md-table-cell>
                      </md-table-row>
                    </md-table-body>
                  </md-table>
                </md-tab>
                <md-tab id="books" md-label="Agregar">
                  <md-card-content>
                    <md-layout md-flex="100" md-gutter="24">
                      <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="45" md-flex-large="45" md-flex-xlarge="45">
                        <md-input-container v-bind:class="{ 'md-input-invalid': val.v_concepto }">
                          <label for="concepto">Conceptos</label>
                          <md-select name="concepto" id="concepto" v-model="con_add.concepto">
                            <md-option v-for="(c,index) in conceptosListado" :key="index" :value="c.id_con" @click.native="valoresConcepto(c)">
                              {{ c.desc_con }}
                              <span>
                                <small>, {{ c.tipo_con.toUpperCase()}}, {{ Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(c.importe_cnh) }}
                                </small>
                              </span>
                            </md-option>
                          </md-select>
                        </md-input-container>
                      </md-layout>
                      <md-layout md-flex-xsmall="40" md-flex-small="40" md-flex-medium="20" md-flex-large="20" md-flex-xlarge="20">
                        <md-input-container v-bind:class="{ 'md-input-invalid': val.v_quincenas }">
                          <label>Semanas</label>
                          <md-input @blur.native="calcularImporteQuincenal()" type="number" min="1" steps="1" v-model="con_add.quincenas" @keyup.native.enter="agregarConcepto()"></md-input>
                        </md-input-container>
                      </md-layout>
                      <md-layout md-flex-xsmall="40" md-flex-small="40" md-flex-medium="20" md-flex-large="20" md-flex-xlarge="20">
                        <md-input-container v-bind:class="{ 'md-input-invalid': val.v_importe_qnal }">
                          <label>Importe sem.</label>
                          <md-input v-model="con_add.importe_qnal" disabled></md-input>
                        </md-input-container>
                      </md-layout>
                      <md-layout md-align="rigth" md-flex-xsmall="20" md-flex-small="20" md-flex-medium="15" md-flex-large="15" md-flex-xlarge="15">
                        <md-button class="md-icon-button md-raised md-accent" @click.native="agregarConcepto()">
                          <md-icon>add</md-icon>
                        </md-button>
                      </md-layout>
                    </md-layout>
                  </md-card-content>
                  <md-table v-if="conceptosNomina.length > 0">
                    <md-table-header>
                      <md-table-row>
                        <md-table-head></md-table-head>
                        <md-table-head>Concepto</md-table-head>
                        <md-table-head>Importe</md-table-head>
                        <md-table-head>Semanas</md-table-head>
                        <md-table-head>Importe sem.</md-table-head>
                      </md-table-row>
                    </md-table-header>
                    <md-table-body>
                      <md-table-row v-for="con in conceptosNomina" :key="con.id_con">
                        <md-table-cell>
                          <md-button class="md-icon-button" @click.native="removerConcepto(con)">
                            <md-icon>delete</md-icon>
                          </md-button>
                        </md-table-cell>
                        <md-table-cell>{{con.desc_con}}</md-table-cell>
                        <md-table-cell>${{con.importe_con}}</md-table-cell>
                        <md-table-cell>{{con.quincenas_con}}</md-table-cell>
                        <md-table-cell>{{con.importe_qnal_con}}</md-table-cell>
                      </md-table-row>
                    </md-table-body>
                  </md-table>
                  <md-card-actions v-if="conceptosNomina.length > 0">
                    <md-button class="md-raised md-primary" @click.native="guardarConceptos()">Agregar conceptos</md-button>
                  </md-card-actions>
                </md-tab>
              </md-tabs>
            </md-card>
          </md-tab>
        </md-tabs>
      </md-layout>
    </md-layout>
    <!--MODAL PARA CAMBIAR EL PLAN DE PAGO DEL EMPLEADO -->
    <!--MODAL PARA CAMBIAR EL PLAN DE PAGO DEL EMPLEADO -->
    <!--MODAL PARA CAMBIAR EL PLAN DE PAGO DEL EMPLEADO -->
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalCambiarPlanPago">
      <md-dialog-title>Cambiar plan de pago del empleado</md-dialog-title>
      <md-dialog-content>
        <md-input-container>
          <label for="id_pln_eph">Plan de pago</label>
          <md-select name="id_pln_eph" id="id_pln_eph" v-model="planDePago" required>
            <md-option v-for="pln in planesListado" :key="pln.id_pln" :value="pln.id_pln">
              {{ pln.nombre_pln }}
              <span>
                <small>, {{numberFormat(pln.salario_qnal_pnh)}} </small>
              </span>
            </md-option>
          </md-select>
        </md-input-container>
        <p>
          <small>Para poder cambiar el plan de pago,<br>debe seleccionar un plan de pago diferente al actual</small>
        </p>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModal('modalCambiarPlanPago')">Cancelar</md-button>
        <md-button class="md-raised md-primary" v-if="planDePago != planDePagoOld" @click.native="cambiarPlanDePago()">Cambiar plan de pago</md-button>
      </md-dialog-actions>
    </md-dialog>
    <!--FIN DEL MODAL PARA CAMBIAR EL PLAN DE PAGO DEL EMPLEADO -->
    <!--FIN DEL MODAL PARA CAMBIAR EL PLAN DE PAGO DEL EMPLEADO -->
    <!--FIN DEL MODAL PARA CAMBIAR EL PLAN DE PAGO DEL EMPLEADO -->

    <!--MODAL PARA CAMBIAR LA IMAGEN DEL EMPLEADO -->
    <!--MODAL PARA CAMBIAR LA IMAGEN DEL EMPLEADO -->
    <!--MODAL PARA CAMBIAR LA IMAGEN DEL EMPLEADO -->
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalCambiarFotoEmpleado">
      <md-dialog-content>
        <md-input-container v-bind:class="{ 'md-input-invalid': val.v_foto }">
          <label>Foto empleado</label>
          <md-file v-model="foto_emn" accept="image/*" @selected="prepararArchivoASubir($event)"></md-file>
        </md-input-container>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModal('modalCambiarFotoEmpleado')">Cancelar</md-button>
        <md-button v-if="foto_subir" @click.native="subirFoto()">Cambiar fotografía</md-button>
      </md-dialog-actions>
    </md-dialog>
    <!--FIN DEL MODAL PARA CAMBIAR LA IMAGEN DEL EMPLEADO -->
    <!--FIN DEL MODAL PARA CAMBIAR LA IMAGEN DEL EMPLEADO -->
    <!--FIN DEL MODAL PARA CAMBIAR LA IMAGEN DEL EMPLEADO -->
  </div>
</template>
<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
import moment from "moment";
export default {
  name: "inicio",
  methods: {
    moment(a, b) {
      return moment(a, b);
    },
    numberFormat(importe) {
      return Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN"
      }).format(importe);
    },
    obtenerEmpleado() {
      this.$http
        .post("empleados/detalle", {
          token: this.$session.get("token"),
          empleado: this.$route.params.empleado
        })
        .then(
          response => {
            if (response.status === 200 && "empleado" in response.body) {
              this.empleado = response.body.empleado;
              this.roles_activos = response.body.roles_activos;
              this.roles_inactivos = response.body.roles_inactivos;
              this.per_ded_activos = response.body.per_ded_activos;
              this.per_ded_inactivos = response.body.per_ded_inactivos;
              this.salarios_historial = response.body.salarios_historial;
              this.planDePago = response.body.empleado.id_pln_pnh;
              this.planDePagoOld = response.body.empleado.id_pln_pnh;
              if (this.empleado.foto_emn) {
                this.foto =
                  "http://api.grupoalarcom.mx/archivos/" +
                  this.$route.params.empleado +
                  "/" +
                  this.empleado.foto_emn;
              }
            } else {
              Snackbar.show({
                text:
                  "No se encontró el empleado que busca. Inténtelo de nuevo.",
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
              this.$router.push("/empleados");
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
            this.$router.push("/empleados");
          }
        );
    },
    //FUNCIONES PARA CONCEPTOS
    obtenerConceptos() {
      this.$http
        .post("conceptos", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "conceptos" in response.body) {
              this.conceptosListado = response.body.conceptos;
            }
          },
          response => {
            Snackbar.show({
              text:
                "No se pudieron obtener los conceptos de nómina. Recargue la página.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    valoresConcepto(c) {
      this.con_add.id = c.id_con;
      this.con_add.desc = c.desc_con;
      this.con_add.tipo = c.tipo_con;
      this.con_add.importe = c.importe_cnh;
      this.con_add.quincenas = 1;
      this.con_add.importe_qnal = c.importe_cnh;
    },
    calcularImporteQuincenal() {
      this.con_add.importe_qnal = this.numberFormat(
        this.con_add.importe / this.con_add.quincenas
      );
    },
    agregarConcepto() {
      this.conceptosNomina.push({
        id_con: this.con_add.id,
        desc_con: this.con_add.desc,
        tipo_con: this.con_add.tipo,
        importe_con: this.con_add.importe,
        quincenas_con: this.con_add.quincenas,
        importe_qnal_con: this.con_add.importe_qnal
      });
      this.con_add.concepto = null;
      this.con_add.quincenas = 1;
      this.con_add.importe_qnal = 0;
    },
    guardarConceptos() {
      this.$http
        .post("conceptos/asignar", {
          token: this.$session.get("token"),
          empleado: this.empleado.id_emn,
          conceptos: this.conceptosNomina
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              this.per_ded_activos = response.body.per_ded_activos;
              this.per_ded_inactivos = response.body.per_ded_inactivos;
              this.conceptosNomina = [];
              this.con_add.concepto = null;
              Snackbar.show({
                text: response.body.msg,
                actionText: "Cerrar",
                pos: "top-right"
              });
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    validarConcepto() {},
    removerConcepto(c) {
      this.conceptosNomina.splice(c, 1);
    },
    //Suspención y activación de conceptos
    cambiarEstatusConcepto(id_pdn, estatus) {
      this.$http
        .post("conceptos/estatus", {
          token: this.$session.get("token"),
          concepto: id_pdn,
          estatus: estatus,
          empleado: this.$route.params.empleado
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              this.per_ded_activos = response.body.per_ded_activos;
              this.per_ded_inactivos = response.body.per_ded_inactivos;
              Snackbar.show({
                text: response.body.msg,
                actionText: "Cerrar",
                pos: "top-right"
              });
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    //Manejo de planes de pago
    obtenerPlanes() {
      this.$http
        .post("planes", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "planes" in response.body) {
              this.planesListado = response.body.planes;
            }
          },
          response => {
            Snackbar.show({
              text:
                "No se pudo establecer conexión con el servidor para obtener los planes de pago.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    cambiarPlanDePago() {
      this.$http
        .post("planes/asignar", {
          token: this.$session.get("token"),
          empleado: this.empleado.id_emn,
          plan: this.planDePago
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              Snackbar.show({
                text: response.body.msg,
                actionText: "Cerrar",
                pos: "top-right"
              });
              this.obtenerEmpleado();
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
      this.cerrarModal("modalCambiarPlanPago");
    },
    //Otros
    irEditarEmpleado() {
      this.$router.push({
        name: "EmpleadosEditar",
        params: { empleado: this.$route.params.empleado }
      });
    },
    abrirModal(m) {
      this.$refs[m].open();
    },
    cerrarModal(m) {
      this.$refs[m].close();
    },
    //Manejo de imagen del empleado
    prepararArchivoASubir(e) {
      this.foto_subir = e[0];
    },
    subirFoto() {
      var formData = new FormData();
      formData.append("token", this.$session.get("token"));
      formData.append("empleado", this.$route.params.empleado);
      formData.append("foto", this.foto_subir);
      this.$http.post("empleados/fotografia", formData).then(
        response => {
          if (response.status === 200 && "msg" in response.body) {
            Snackbar.show({
              text: response.body.msg,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false
            });
            this.$router.push("/empleados");
          } else {
            Snackbar.show({
              text: response.body.error,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        },
        response => {
          Snackbar.show({
            text:
              "No se pudieron obtener los puestos de empleado. Recargue la página.",
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      );
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerEmpleado();
  },
  mounted() {
    //Lo hacemos despues ya que no es importante
    this.obtenerConceptos();
    this.obtenerPlanes();
  },
  data() {
    return {
      msg: "Inicio",
      editar_nomina: this.$parent.permisos_editar_nomina,
      empleado: {},
      roles_activos: [],
      roles_inactivos: [],
      per_ded_activos: [],
      per_ded_inactivos: [],
      salarios_historial: [],
      planesListado: [],
      planDePago: null,
      val: {
        v_con_id: null,
        v_con_desc: null,
        v_con_importe: null,
        v_con_quincenas: null,
        v_con_importe_qnal: null
      },
      con_add: {
        id: null,
        desc: null,
        importe: 0,
        quincenas: 1,
        importe_qnal: 0
      },
      conceptosNomina: [],
      conceptosListado: [],
      foto_emn: null,
      foto_subir: null,
      foto: null
    };
  }
};
</script>


// WEBPACK FOOTER //
// EmpleadosDetalle.vue?1ce5cdfe